var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { MultichainActionType } from '@popup/multichain/actions/action-type.enum';
export const resetNav = () => (dispatch, getState) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch({ type: MultichainActionType.RESET_NAV });
});
export const navigateTo = (screen, resetStack = false) => (dispatch, getState) => __awaiter(void 0, void 0, void 0, function* () {
    // AnalyticsTracker.trackNav(screen);
    dispatch({
        type: MultichainActionType.NAVIGATE_TO,
        payload: { nextPage: screen, resetStack },
    });
});
export const navigateToWithParams = (screen, params, resetStack = false) => (dispatch, getState) => __awaiter(void 0, void 0, void 0, function* () {
    // AnalyticsTracker.trackNav(screen);
    dispatch({
        type: MultichainActionType.NAVIGATE_TO_WITH_PARAMS,
        payload: { nextPage: screen, params, resetStack },
    });
});
export const goBack = () => (dispatch, getState) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch({ type: MultichainActionType.GO_BACK });
});
export const goBackToThenNavigate = (navigateTo, goBackTo) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch({
        type: MultichainActionType.GO_BACK_TO_THEN_NAVIGATE,
        payload: { goBackTo, nextPage: navigateTo },
    });
});
